<template>
    <div>
        <span @click="expand = !expand" class="object-name" :class="{error: isErrorObject}">
            <span v-if="isGlobalPropertiesObject">
                <i class="fal fa-cog"></i>
            </span>
            {{ label || getWorkflowObjectLabelWithBlockNamePrefix(workflowObject) }}
            <AppExpandChevron :show="expand"/>
        </span>
        <span v-if="withObjectSelect && !isGlobalPropertiesObject"
              v-tooltip="'Select full object reference'"
              @click="onFieldSelect([])"
              class="pl-2 text-success clickable">
            <i class="far fa-check"></i>
        </span>
        <br>
        <template v-if="expand">
            <WorkflowObjectField
                v-for="(field, idx) in filteredFields" :key="workflowObject.label + idx"
                :field="field"
                :fieldPath="[field.name]"
                :onSelect="onFieldSelect"
                :withObjectSelect="withObjectSelect"
                :searchExpand="Boolean(searchString)"
                @selectCategory="selectCategory"
                :showDebugName="isEnabledWorkflowDebugMode"
                :selectedCategories="selectedCategories"/>
        </template>
    </div>
</template>

<script>
import AppExpandChevron from '../../../../../components/shared/AppExpandChevron'
import WorkflowObjectField from './WorkflowObjectField'
import {mapGetters} from 'vuex'
import {
    WORKFLOW_OBJ_TYPE_GLOBAL_PROPERTIES,
    WORKFLOW_OBJ_TYPE_MODULE_ERROR_INTERFACE
} from '../../../../../models/workflow'

export default {
    name: 'WorkflowObjectTree',
    components: {WorkflowObjectField, AppExpandChevron},
    props: {
        workflowObject: {
            type: Object,
            required: true
        },
        label: {
            type: String,
            default: ''
        },
        searchString: {
            type: String,
            default: ''
        },
        expanded: {
            type: Boolean,
            default: true
        },
        withObjectSelect: {
            type: Boolean,
            required: false,
            default: false
        },
        selectedCategories: {
            type: Object,
            required: false
        }
    },
    data() {
        return {
            expand: this.expanded
        }
    },
    computed: {
        ...mapGetters([
            'getWorkflowObjectLabelWithBlockNamePrefix',
            'isEnabledWorkflowDebugMode'
        ]),

        isGlobalPropertiesObject() {
            return this.workflowObject.type === WORKFLOW_OBJ_TYPE_GLOBAL_PROPERTIES
        },

        fields() {
            return _.isArray(this.workflowObject.data) ? this.workflowObject.data : []
        },

        filteredFields() {
            return this.fields.filter(f => {
                return f && f.name && f.label &&
                    (f.label.toLowerCase().startsWith(this.searchString.toLowerCase()) ||
                        (_.isArray(f.spec) && f.spec.some(s => s.label.toLowerCase().startsWith(this.searchString.toLowerCase()))))
            })
        },

        isErrorObject() {
            return this.workflowObject.type === WORKFLOW_OBJ_TYPE_MODULE_ERROR_INTERFACE
        }
    },
    methods: {
        selectCategory(data) {
            this.$emit('selectCategory', data)
        },
        onFieldSelect(fieldPath) {
            this.$emit('select', {
                workflowObject: this.workflowObject,
                fieldPath
            })
        }
    }
}
</script>

<style scoped lang="scss">
    .object-name {
        border-radius: 4px;
        padding: 2px 8px;
        background: $color-success-light;

        &:hover {
            cursor: pointer;
        }

        &.error {
            background: $color-danger;
            color: white;
        }
    }
</style>
